import type {
  BodyItemClassNameFunction,
  BodyRowClassNameFunction,
  Column,
  CustomBodyRowClassName,
  HeaderItemClassNameFunction,
} from '../components/DataTable/';
import {
  cellAlignmentVariant,
  clickableRowClass,
  tableCellClass,
} from '../components/DataTable/DataTable.css.ts';

export const headerClassNameFunction: HeaderItemClassNameFunction = (
  column: Column,
): string => {
  return `header-item-${column.align || 'left'} ${
    column.lastFixed ? 'header-item-last-fixed' : ''
  }`;
};

export const itemClassNameFunction: (
  headers: Column[],
) => BodyItemClassNameFunction =
  (headers: Column[]) =>
  (columnName: string): string => {
    const classes = [tableCellClass];

    const columnConfig: Column | undefined = headers.find(
      (col) => col.value === columnName,
    );

    if (columnConfig) {
      classes.push(cellAlignmentVariant[columnConfig.align || 'left']);
    }

    return classes.join(' ');
  };

type RowClassNameFunctionPayload = {
  rowIsClickable?: boolean;
  customRowClassName?: CustomBodyRowClassName;
};
export const rowClassNameFunction: (
  payload: RowClassNameFunctionPayload,
) => BodyRowClassNameFunction =
  ({ rowIsClickable, customRowClassName }) =>
  (item, rowNumber): string => {
    const classes: string[] = [];

    if (rowIsClickable) {
      classes.push(clickableRowClass);
    }

    if (item?.checkbox) {
      classes.push(SELECTED_ROW_CLASS_NAME);
    }

    const customClasses =
      typeof customRowClassName === 'function'
        ? customRowClassName(item, rowNumber)
        : customRowClassName;

    if (customClasses) {
      classes.push(customClasses);
    }

    return classes.join(' ');
  };

export const ITEMS_PER_PAGE_DEFAULT_OPTIONS = [10, 25, 50, 100];

export const HIDDEN_SELECTION_CLASS_NAME = 'hidden-selection';

export const NOT_SELECTABLE_ROW_CLASS_NAME = 'not-selectable-row';

export const DISABLED_ROW_CLASS_NAME = 'disabled-row';

export const SELECTED_ROW_CLASS_NAME = 'selected-row';

export const ERROR_ROW_CLASS_NAME = 'error-row';
